import { render, staticRenderFns } from "./CbrUpdatesPage.vue?vue&type=template&id=e23b03cc&lang=pug&"
import script from "./CbrUpdatesPage.vue?vue&type=script&lang=js&"
export * from "./CbrUpdatesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports